import { FC, memo } from 'react';
import styled from 'styled-components';
import { MessageCircle } from 'lucide-react';

import theme from 'theme';
import { useDownloadAppModal } from '@hooks/useDownloadAppModal';
import { useShowDataById } from '@redux/selectors/shows';
import LogoButton from '@components/show/menu/components/LogoButton';
import ParticipantsButton from '@components/show/menu/components/ParticipantsButton';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const Container = styled.div<{ $isLiveShow?: boolean }>`
  display: none;
  position: fixed;
  bottom: ${({ $isLiveShow }) => ($isLiveShow ? '0' : '60px')};
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.black};
  border-top: 1px solid ${({ theme }) => theme.colors.grey[700]};
  padding: 8px 16px;
  z-index: 10;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
`;

const ChatButton = styled(TouchableOpacity)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const JoinButton = styled.div`
  min-width: 80px;
`;

type Props = {
  showId: string;
  onChatToggle: () => void;
  isLiveShow?: boolean;
};

const MobileBottomMenu: FC<Props> = ({
  showId,
  onChatToggle,
  isLiveShow = false,
}) => {
  const show = useShowDataById(showId);
  const { openDownloadAppModal } = useDownloadAppModal();

  return (
    <Container $isLiveShow={isLiveShow}>
      <ChatButton onClick={onChatToggle}>
        <MessageCircle size={36} color={theme.colors.white} />
      </ChatButton>

      {isLiveShow && (
        <ParticipantsButton
          count={show?.listenersCount}
          onClick={() => openDownloadAppModal()}
          disabled
        />
      )}

      {isLiveShow && (
        <JoinButton>
          <LogoButton text='Join Now' onClick={() => openDownloadAppModal()} />
        </JoinButton>
      )}
    </Container>
  );
};

export default memo(MobileBottomMenu);
